




















































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { URL_EMAIL_SERVICE as URL } from "../constants";
@Component
export default class Presenca extends Vue {
  get arquivos() {
    return [
      {
        title: "Características Tecnológicas",
        href: "./files/caracteristicas_tecnologicas.pdf",
      },
      {
        title: "Monitoramento do Portal",
        href: "./files/monitoramento_portal.pdf",
      },
      {
        title: "Gestão de Acesso",
        href: "./files/gestao_de_acesso.pdf",
      },
      {
        title: "Rede Física",
        href: "../files/rede_fisica.pdf",
      },
      {
        title: "Rede de Ensino",
        href: "./files/rede_de_ensino.pdf",
      },
      {
        title: "Matrícula",
        href: "./files/matricula.pdf",
      },
      {
        title: "Enturmação",
        href: "./files/enturmacao.pdf",
      },
      {
        title: "Acompanhamento Acadêmico",
        href: "./files/acompanhamento_academico.pdf",
      },
      {
        title: "Diário de Classe On-line",
        href: "./files/diario_de_classe_online.pdf",
      },
      {
        title: "Diário de Classe Móvel",
        href: "./files/diario_de_classe_movel.pdf",
      },
      {
        title: "Material Escolar",
        href: "/files/material_escolar.pdf",
      },
      {
        title: "Abertura e Encerramento do Ano Letivo",
        href: "./files/abertura_e_encerramento_do_ano_letivo.pdf",
      },
      {
        title: "Documentação Escolar",
        href: "./files/documentacao_escolar.pdf",
      },
      {
        title: "Censo Escolar",
        href: "./files/censo_escolar.pdf",
      },
      {
        title: "Participação de Familiares em Reunião",
        href: "./files/participacao_de_familiares_em_reuniao.pdf",
      },
      {
        title: "Servidores",
        href: "./files/servidores.pdf",
      },
      {
        title: "Quadro de Horário",
        href: "./files/quadro_de_horario.pdf",
      },
      {
        title: "Frequência de Servidores",
        href: "./files/frequencia_de_servidores.pdf",
      },
      {
        title: "Gestão de Capacitação",
        href: "./files/gestao_de_capacitacao.pdf",
      },
      {
        title: "Concurso de Remoção",
        href: "./files/concurso_de_remocao.pdf",
      },
      {
        title: "Transporte Escolar Municipal",
        href: "./files/transporte_escolar_municipal.pdf",
      },
      {
        title: "Transporte Escolar Estadual",
        href: "./files/transporte_escolar_estadual.pdf",
      },
      {
        title: "Patrimônio",
        href: "./files/patrimonio.pdf",
      },
      {
        title: "Financeiro",
        href: "./files/financeiro.pdf",
      },
      {
        title: "Alimentação Escolar",
        href: "./files/alimentacao_escolar.pdf",
      },
      {
        title: "Acompanhamento Nutricional",
        href: "./files/acompanhamento_nutricional.pdf",
      },
      {
        title: "Monitoramento de Frequência",
        href: "./files/monitoramento_de_frequencia.pdf",
      },
      {
        title: "Bolsa Escola",
        href: "./files/bolsa_escola.pdf",
      },

      {
        title: "Educador Conectado",
        href: "./files/educador_conectado.pdf",
      },

      {
        title: "Família Conectada",
        href: "./files/familia_conectada.pdf",
      },

      {
        title: "Portal Educacional",
        href: "./files/portal_educacional.pdf",
      },

      {
        title: "Biblioteca",
        href: "./files/biblioteca.pdf",
      },

      {
        title: "Gestão de Infraestrutura",
        href: "./files/gestao_de_infraestrutura.pdf",
      },
    ];
  }
}
